export default "__VITE_ASSET__B63Me2js__"